import Vue from 'vue';
import Component from 'vue-class-component';
import ChildComponentCollection from './ChildComponentCollection';

@Component
export default class ParentComponentMixin extends Vue {
  private initParentComponentMixinCalled = false;
  private childComponentCollection = new ChildComponentCollection<Vue>();
  private childComponentNames: string[] = [];
  private childAddedCallback: ((addedItem: Vue) => void) | null = null;
  private childRemovedCallback: ((removedItem: Vue) => void) | null = null;

  initParentComponentMixin (
    childComponentCollection: ChildComponentCollection<Vue>,
    childComponentNames: string[],
    childAddedCallback?: (addedItem: Vue) => void,
    childRemovedCallback?: (removedItem: Vue) => void,
  ): void {
    this.initParentComponentMixinCalled = true;
    this.childComponentNames = childComponentNames;
    this.childComponentCollection = childComponentCollection;
    this.childAddedCallback = childAddedCallback || null;
    this.childRemovedCallback = childRemovedCallback || null;
  }

  mounted () {
    if (!this.initParentComponentMixinCalled) {
      // eslint-disable-next-line no-console
      console.error('ParentComponentMixin not correctly initialized yet! Please add initParentComponentMixin() call in the created() method of your parent component.');
    }
    this.childComponentNames.forEach((childComponentName: string) => {
      this.$el.addEventListener(`childComponentMounted_${childComponentName}`, this.onChildComponentMounted, { passive: true });
    });
  }

  destroyed () {
    this.childComponentNames.forEach((childComponentName: string) => {
      this.$el.removeEventListener(`childComponentMounted_${childComponentName}`, this.onChildComponentMounted);
    });
  }

  onChildComponentMounted (evt: object | CustomEvent) {
    if (evt instanceof CustomEvent && evt.detail.item) {
      const addedItem = evt.detail.item;
      const removedItems = this.childComponentCollection.cleanUp();
      removedItems.forEach((removedItem) => {
        if (this.childRemovedCallback) {
          this.childRemovedCallback(removedItem);
        }
      });
      addedItem.index = this.childComponentCollection.length;
      this.childComponentCollection.push(addedItem);
      if (this.childAddedCallback) {
        this.childAddedCallback(addedItem);
      }
    }
  }
}
